import {
	createCustomMetric,
	createPageLoadMetric,
	createPageSegmentLoadMetric,
} from '@confluence/browser-metrics/entry-points/metricConfigs';
import {
	FABRIC_PUBLISH_PAGE_KEY,
	EDIT_PAGE_LOAD_KEY,
	NCS_CONNECTED_FMP_KEY,
	EMBEDDED_EDIT_PAGE_LOAD_KEY,
	EDITOR_SEGMENT_KEY,
} from '@confluence/browser-metrics/entry-points/metric-keys';

export const FABRIC_PUBLISH_PAGE_METRIC = createCustomMetric({
	key: FABRIC_PUBLISH_PAGE_KEY,
	histogram: {
		duration: '1000_2000_3000_4000_5000_6000_7000_8000_9000',
	},
});

export const EDIT_PAGE_LOAD = createPageLoadMetric({
	key: EDIT_PAGE_LOAD_KEY,
	timings: [
		{ key: 'onBeforeEditor', endMark: 'onBeforeEditor' },
		{ key: 'editorRendered', startMark: 'onBeforeEditor' },
	],
});

export const EDITOR_METRIC = createPageSegmentLoadMetric({
	key: EDITOR_SEGMENT_KEY,
});

export const NCS_CONNECTED_FMP = createPageSegmentLoadMetric({
	key: NCS_CONNECTED_FMP_KEY,
});

export const EMBEDDED_EDIT_PAGE_LOAD = createPageLoadMetric({
	key: EMBEDDED_EDIT_PAGE_LOAD_KEY,
});
